import { Component } from '@angular/core';
import { AssessmentService } from 'src/app/services/assessment.service';

@Component({
  selector: 'app-assessment-test-list',
  templateUrl: './assessment-test-list.component.html',
  styleUrls: ['./assessment-test-list.component.scss']
})
export class AssessmentTestListComponent {
  total: number;
  assessments: any[];
  limit = 10;
  constructor(private assessmentService: AssessmentService) { }

  ngOnInit() { this.load(); }

  load(from = 0) {
    delete this.assessments;
    setTimeout(async () => {
      var result = await this.assessmentService.search({}, from, this.limit);
      this.assessments = result.assessments;
      this.total = result.total;
    });
  }
}
